export default function Exercises() {
  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-4">Exercises</h1>
      <div className="text-lg"><h2>Exercises Overview</h2></div>
      <p className="mt-4 text-gray-500 text-sm">Path: /git/topic/Exercises</p>
    </div>
  );
}
